import type { Nullish } from "~/@types/generics"
import type { PromoCardProps } from "~/components/ui/PromoCard"
import { type TVideo } from "~/components/ui/Video"

export function isVimeoVideoUrl(data: PromoCardProps["video"]): data is string {
  return typeof data === "string" && Boolean(data)
}

export function isVideo(data: PromoCardProps["video"]): data is { desktop: TVideo; mobile: Nullish<TVideo> } {
  return Boolean(data && typeof data === "object" && "desktop" in data)
}
